export function find_by_id(list, id) {
    return list.find(item => item.id === id);
}

export function remove_by_id(list, id) {
    return list.filter(item => item.id !== id);
}

export function insert(array, index, element) {
    return [...array.slice(0, index), element, ...array.slice(index)];
}
